module.exports = __webpack_public_path__ + "static/media/FR-73.fe9f5e63.geojson";